import { DatePicker, Form, Modal, Select, message } from "antd";
import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import { ApiService } from "../api";
import { OptionProps } from "antd/es/select";
import { debounce } from "lodash";
import moment from "moment";
import { openNotificationWithIcon } from "../constants";

type Props = {
  requestId: string;
  visible: boolean;
  setVisible: (visible: boolean) => void;
  fetch: number;
  setFetch: (fetch: number) => void;
};

const ExtendModal = (props: Props) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const handleSubmit = async (values: any) => {
    try {
      await ApiService.apiMainExtendRequestCreate({
        request_id: parseInt(props.requestId),
        finish_date: new Date(values.finishDate).toLocaleDateString("en-CA", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }),
      });
      openNotificationWithIcon(
        "success",
        t("Request has been extended sucessfully")
      );
    } catch (e) {
      openNotificationWithIcon("error");
    }
    props.setFetch(props.fetch + 1);
    props.setVisible(false);
  };

  return (
    <Modal
      title={t("Extend request")}
      open={props.visible}
      onCancel={() => props.setVisible(false)}
      onOk={() => form.submit()}
    >
      <Form form={form} onFinish={handleSubmit}>
        <Form.Item
          label={t("Extend date")}
          name="finishDate"
          rules={[
            {
              required: true,
              message: t("Please input date."),
            },
          ]}
          noStyle
        >
          <DatePicker />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ExtendModal;
